<template>
  <div class="container">
    <el-card>
      <div slot="header">基本参数设置</div>
      <div class="centerBox">
        <div class="basicParam" style="margin-right: 30px">
          <div class="title">基本参数设置</div>
          <el-form
            ref="form"
            :model="basicForm"
            label-width="250px"
            size="small"
          >
            <el-row :gutter="20">
              <el-col :lg="22">
                <el-form-item label="电表离线判定间隔时长（小时）：">
                  <el-input
                    v-model="basicForm.OFF_INTERVAL_METER.dicValue"
                    oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1')"
                    clearable
                  >
                    48</el-input
                  >
                </el-form-item>
              </el-col>
              <el-col :lg="22">
                <el-form-item label="水表离线判定间隔时长（小时）：">
                  <el-input
                    v-model="basicForm.OFF_INTERVAL_WATER.dicValue"
                    oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1')"
                    clearable
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="btns">
            <el-button type="primary" @click="sava()">保存</el-button>
            <el-button
              type="primary"
              style="background-color: #bababa !important"
              @click="detail()"
              >取消
            </el-button>
          </div>
        </div>
        <div class="basicParam" style="margin-right: 30px">
          <div class="title">系统名称设置</div>
          <el-form
            ref="form"
            :model="systemForm"
            label-width="250px"
            size="small"
          >
            <el-row :gutter="20">
              <el-col :lg="22">
                <el-form-item label="系统名称">
                  <el-input
                    v-model="systemForm.SYSTEM_TITLE.dicValue"
                    clearable
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="btns">
            <el-button type="primary" @click="savaSystem()">保存</el-button>
            <el-button
              type="primary"
              style="background-color: #bababa !important"
              @click="detailSystem()"
              >取消
            </el-button>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { detail, sava } from '../../api/system/basicParameters.js';
export default {
  data() {
    return {
      basicForm: {
        OFF_INTERVAL_METER: {},
        OFF_INTERVAL_WATER: {},
      },
      systemForm: {
        SYSTEM_TITLE: {},
      },
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  watch: {},
  methods: {
    async init() {
      await this.detail();
      await this.detailSystem();
    },
    // 查询
    async detail() {
      let data = {
        paramPrefix: 'OFF_INTERVAL',
      };
      let res = await detail(data).then();
      this.basicForm = res.data;
    },
    // 保存
    async sava() {
      await sava(this.basicForm).then();
      this.msgSuccess('保存成功');
      await this.detail();
    },
    // 查询
    async detailSystem() {
      let data = {
        paramPrefix: 'SYSTEM_TITLE',
      };
      let res = await detail(data).then();
      this.systemForm = res.data;
    },
    // 保存
    async savaSystem() {
      await sava(this.systemForm).then();
      this.msgSuccess('保存成功');
      await this.detailSystem();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0 10px;
  height: 100%;
}

/deep/ .el-card__header {
  background-color: var(--secondColor) !important;
  color: var(--whiteColor);
}

.basicParam {
  box-sizing: border-box;
  width: 50%;
  border-radius: 5px;
  box-shadow: 0px 0px 4px 2px #ccc;
  margin-top: 15px;
  padding: 20px;
  position: relative;

  .title {
    padding-bottom: 15px;
    margin-bottom: 15px;
    border-bottom: 1px solid #ccc;
  }

  .el-form {
    margin-bottom: 50px;
  }

  .btns {
    position: absolute;
    bottom: 20px;
    width: 100%;
    text-align: center;
  }
}

// @media screen and (max-width: 1200px) {
//   .centerBox {
//     width: 100% !important;
//   }
// }
.centerBox {
  width: 95%;
  height: 80%;
  margin: 0 auto;
  display: flex;
}
</style>
